// src/hooks/hotelRoomCategories/useForceDeleteHotelRoomCategory.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteHotelRoomCategory as forceDeleteHotelRoomCategoryAPI } from "../../api/apiHotelRoomCategories";
import parseError from "../../utils/parseError";

const useForceDeleteHotelRoomCategory = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDelete, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteHotelRoomCategoryAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel room category permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelRoomCategories"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete hotel room category");
        },
    });

    return { forceDeleteHotelRoomCategory: forceDelete, isForceDelete };
};

export default useForceDeleteHotelRoomCategory;
